import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import PortalLayout from "@/components/PortalLayout";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Coaches from "@/pages/Coaches";
import Roster from "@/pages/Roster";
import Schedule from "@/pages/Schedule";
import Scores from "@/pages/Scores";
import Camps from "@/pages/Camps";
import Tryouts from "@/pages/Tryouts";
import Sponsors from "@/pages/Sponsors";
import Merch from "@/pages/Merch";
import Donate from "@/pages/Donate";
import Gallery from "@/pages/Gallery";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";

import Login from "@/pages/Login";
import Register from "@/pages/Register";

import PortalDashboard from "@/pages/portal/Dashboard";
import PortalAnnouncements from "@/pages/portal/Announcements";
import PortalCalendar from "@/pages/portal/Calendar";
import PortalDocuments from "@/pages/portal/Documents";
import PortalPayments from "@/pages/portal/Payments";
import PortalProfile from "@/pages/portal/Profile";
import PortalVolunteer from "@/pages/portal/Volunteer";
import PortalService from "@/pages/portal/Service";

import Admin from "@/pages/admin/Admin";
import Accounts from "@/pages/admin/Accounts";
import ManagePayments from "@/pages/admin/ManagePayments";
import AdminPaymentsHub from "@/pages/admin/AdminPaymentsHub";

const Pub = (Page) => <PublicLayout><Page /></PublicLayout>;
const wrap = (Page) => <PublicLayout><Page /></PublicLayout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
        <Routes>
          <Route path="/" element={wrap(Home)} />
          <Route path="/about" element={wrap(About)} />
          <Route path="/coaches" element={wrap(Coaches)} />
          <Route path="/roster" element={wrap(Roster)} />
          <Route path="/schedule" element={wrap(Schedule)} />
          <Route path="/scores" element={wrap(Scores)} />
          <Route path="/camps" element={wrap(Camps)} />
          <Route path="/tryouts" element={wrap(Tryouts)} />
          <Route path="/sponsors" element={wrap(Sponsors)} />
          <Route path="/merch" element={wrap(Merch)} />
          <Route path="/donate" element={wrap(Donate)} />
          <Route path="/gallery" element={wrap(Gallery)} />
          <Route path="/faq" element={wrap(Faq)} />
          <Route path="/contact" element={wrap(Contact)} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/portal" element={<ProtectedRoute><PortalLayout><PortalDashboard /></PortalLayout></ProtectedRoute>} />
          <Route path="/portal/announcements" element={<ProtectedRoute><PortalLayout><PortalAnnouncements /></PortalLayout></ProtectedRoute>} />
          <Route path="/portal/calendar" element={<ProtectedRoute><PortalLayout><PortalCalendar /></PortalLayout></ProtectedRoute>} />
          <Route path="/portal/documents" element={<ProtectedRoute><PortalLayout><PortalDocuments /></PortalLayout></ProtectedRoute>} />
          <Route path="/portal/payments" element={<ProtectedRoute><PortalLayout><PortalPayments /></PortalLayout></ProtectedRoute>} />
          <Route path="/portal/profile" element={<ProtectedRoute><PortalLayout><PortalProfile /></PortalLayout></ProtectedRoute>} />
          <Route path="/portal/volunteer" element={<ProtectedRoute><PortalLayout><PortalVolunteer /></PortalLayout></ProtectedRoute>} />
          <Route path="/portal/service" element={<ProtectedRoute><PortalLayout><PortalService /></PortalLayout></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute roles={["admin", "coach"]}><PortalLayout><Admin /></PortalLayout></ProtectedRoute>} />
          <Route path="/admin/accounts" element={<ProtectedRoute roles={["admin", "coach"]}><PortalLayout><Accounts /></PortalLayout></ProtectedRoute>} />
          <Route path="/admin/payments" element={<ProtectedRoute roles={["admin"]}><PortalLayout><AdminPaymentsHub /></PortalLayout></ProtectedRoute>} />
          <Route path="/admin/accounts/:userId/payments" element={<ProtectedRoute roles={["admin"]}><PortalLayout><ManagePayments /></PortalLayout></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
